// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3f6Am","delete":"styles_delete__FWv57","update":"styles_update__3XZK9","add":"styles_add__1HUzL"};